import React from 'react'
import {
  defineMessages,
  FormattedMessage
} from 'react-intl'
import './styles.css'
import cn from 'classnames'
import Icon from 'components/icons'
import colors from '../../../styles/colors.css'

const messages = defineMessages({
  streamPaused: 'Video Stream paused',
  inmateMovedTablet: 'The inmate has moved the tablet to a place where use is prohibited. The video will be paused until the tablet is returned to an approved area.',
  participantPaused: 'Your participant has paused the video stream, and will resume once they unpause it.',
})

const getNotificationClassName = (videoDisabled, remoteTracks) => {
  const disabledByUser = remoteTracks && remoteTracks.videoDisabled && remoteTracks.videoDisabledReason === 'user_action' || false
  const disabledByPowerOrNFC = remoteTracks && remoteTracks.videoDisabled && ['power_action', 'nfc_action'].includes(remoteTracks.videoDisabledReason) || false
  if (disabledByPowerOrNFC) {
    return 'orangeBackground'
  } else if (disabledByUser || videoDisabled) {
    return 'blueBackground'
  }
}

const getNotificationMessage = (videoDisabled, remoteTracks) => {
  const disabledByUser = remoteTracks && remoteTracks.videoDisabled && remoteTracks.videoDisabledReason === 'user_action' || false
  const disabledByPowerOrNFC = remoteTracks && remoteTracks.videoDisabled && ['power_action', 'nfc_action'].includes(remoteTracks.videoDisabledReason) || false

  if (disabledByPowerOrNFC) {
    return messages.inmateMovedTablet
  } else if (disabledByUser || videoDisabled) {
    return messages.participantPaused
  }
}

function VideoStreamDisabledNotification(props) {
  const {
    remoteVideoDisabled,
    remoteTracks
  } = props

  return (
    <div styleName={cn('tabletUnplugged', getNotificationClassName(remoteVideoDisabled, remoteTracks))}>
      <div styleName='centerContent'>
        <div styleName='videoIcon'>
          <Icon name='cam-off' fill={colors.shade0} />
        </div>
        <h2 styleName='notificationTitle'>
          <FormattedMessage {...messages.streamPaused} />
        </h2>
        <p styleName='notificationMessage'>
          <FormattedMessage {...getNotificationMessage(remoteVideoDisabled, remoteTracks)} />
        </p>
      </div>
    </div>
  )
}

export default VideoStreamDisabledNotification